import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { RetrabalhoPallet } from '../../types/qualidade';
import { retrabalhosService } from '../../services';

const columns: ResourceColumn<RetrabalhoPallet>[] = [
  { header: 'Inspeção', accessor: 'inspecao' },
  { header: 'Responsável', accessor: 'responsavel' },
  { header: 'Ação', accessor: 'acao' },
  { header: 'Custo', accessor: 'custo' },
];

export const RetrabalhosListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Retrabalhos"
    description="Tratativas aplicadas aos defeitos."
    columns={columns}
    service={retrabalhosService}
    createPath="/admin/qualidade/retrabalhos/novo"
      onEdit={(item) => item.id && navigate("/admin/qualidade/retrabalhos/editar", { state: { record: item } })}
  />
  );
};